import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface DeliverableMetric {
  id: string;
  name: string | null;
  status: string;
  solution_type: number | null;
  submitted_at: string | null;
  file_url: string | null;
  user_id: string;
  user_name: string;
  area: string | null;
  organization_id: string | null;
  organization_name: string | null;
  workshop_title: string | null;
  workshop_deleted: boolean;
}

const STATUS_LABELS: Record<string, string> = {
  not_started: 'No Iniciado',
  in_progress: 'En Progreso',
  submitted: 'Enviado',
  validated: 'Validado',
  needs_revision: 'Requiere Revisión',
};

export function useDeliverablesMetrics() {
  const deliverablesQuery = useQuery({
    queryKey: ['admin-deliverables-metrics'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('participant_deliverables')
        .select(`
          id, name, status, solution_type, submitted_at, file_url, user_id,
          profiles!participant_deliverables_user_id_fkey (
            full_name, area, organization_id,
            organizations:organization_id (name)
          ),
          program_workshops!participant_deliverables_workshop_id_fkey (
            title, deleted_at
          )
        `)
        .order('submitted_at', { ascending: false });
      if (error) throw error;

      return (data ?? []).map((d: any) => ({
        id: d.id,
        name: d.name,
        status: d.status ?? 'not_started',
        solution_type: d.solution_type,
        submitted_at: d.submitted_at,
        file_url: d.file_url,
        user_id: d.user_id,
        user_name: d.profiles?.full_name ?? '',
        area: d.profiles?.area ?? null,
        organization_id: d.profiles?.organization_id ?? null,
        organization_name: (d.profiles?.organizations as any)?.name ?? null,
        workshop_title: (d.program_workshops as any)?.title ?? null,
        workshop_deleted: !!(d.program_workshops as any)?.deleted_at,
      })) as DeliverableMetric[];
    },
  });

  const orgsQuery = useQuery({
    queryKey: ['admin-metrics-orgs'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('organizations')
        .select('id, name, logo_url')
        .order('name');
      if (error) throw error;
      return data ?? [];
    },
  });

  return {
    deliverables: deliverablesQuery.data ?? [],
    organizations: orgsQuery.data ?? [],
    isLoading: deliverablesQuery.isLoading || orgsQuery.isLoading,
    STATUS_LABELS,
  };
}
